import { Injectable } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { CommonService } from '../common.service';
import { appSettings, errorMessages } from '../../settings';
import * as moment from 'moment';
import { SignalRConnection, BroadcastEventListener, ConnectionStatus, ConnectionStatuses } from 'ng2-signalr';
import { UserPreference } from '../../models/UserPreference';


@Injectable()
export class WavesinqueueService {

  private hub: SignalRConnection;
  labelSetting = {
    normal: {
      show: true,
      position: 'outside',
      offset: [10, 0],
      textStyle: {
        fontSize: 18,
        fontFamily: 'lato',
        color: '#ccc'
      }
    }
  };

  constructor(private _dashboardService: DashboardService,
    private _commonService: CommonService) { }

  chartOptions() {
    return {
      color: ['#3398DB'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      grid: {
        left: '10%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
            data: [],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              length: "100%",
              //rotate: 35,
              color: "#fff",
              margin: 20,
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            interval: 0,
            length: "100%",
            //rotate: 30,
            color: "#fff"
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          splitLine: {
            show: false
          },
        }
      ],
      series: [
        {
          name: 'Waves In Queue',
          type: 'bar',
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          barMaxWidth : '50px',
          data: []
        }
      ]
    };
  }

  init(widget: any) {
    console.log('Waves In Queue')
    widget.dataLoaded = false;
    let currentDateTime = moment().toDate().getTime();
    widget.Title = 'Waves In Queue';
    widget.initcreationtime = currentDateTime;
    widget.widgetcreationtime = currentDateTime;
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.hub.start()
      .then(() => {
        console.log('Connection started!');
        widget.ConnectionId = widget.hub.id;
        let userPref: UserPreference = this._commonService.getUserPreference();
        widget.hub.listenFor('broadcastWavesInQueue')
          .subscribe((result: any) => {
            console.log('broadcastWavesInQueue', result);
            let resultwid;
            let resultcreationtime;
            let lastUpdatedTime;
            
            if (result && result.length > 0) {
              //console.log(result[0].IsNoDataFound);
              widget.IfNoDataFound = result[0].IsNoDataFound;
              resultwid = result[0].widgetid;
              resultcreationtime = result[0].widgetcreationtime;
              lastUpdatedTime = result[0].LastUpdateTime;
            }
            else {
              widget.errorMessage = errorMessages.noWidgetData;
            }


            if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime) {
              widget.dataLoaded = false;
              widget.chartOptions = this.chartOptions();
              widget.errorMessage = null;
              //need to format this 
              let series = [];
              let xaxis = [];

              result.forEach(el => {
                series.push([el.KPITYPE, el.KPIVALUE]);
                xaxis.push(el.KPITYPE);
              });

              if (widget.IfNoDataFound) {
                widget.errorMessage = errorMessages.noWidgetData;
              }
              else {
                widget.errorMessage = null;
              }
              widget.chartOptions.series[0].data = series;
              widget.chartOptions.xAxis[0].data = xaxis;
            }
            widget.dataLoaded = true;
            this._commonService.lastUpdatedTime = lastUpdatedTime;
          }
            , err => {
              console.log('listenFor broadcastWavesInQueue error', err);
            }
          );

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = "WAVESINQUEUE";
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;

        widgetData.ConnectionId = widget.hub.id;
        widget.hub.invoke('GetWidgetData', widgetData)
          .then(data => {
            //console.log('GetWidgetData', data);
          })
          .catch(err => {
            console.log('Error GetWidgetData', err);
          })

      })
      .catch(err => {
        console.log('Error while establishing connection', err);
      });
  }

  reload(widget: any) {
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.chartOptions = this.chartOptions();

    widget.hub.start()
      .then(() => {
        console.log('Connection started!');
        let widgetSettingParam = {
          WidgetType: "WAVESINQUEUE",
          WidgetId: widget.widgetId,
          CreatedTime: widget.widgetcreationtime,
          ConnectionId: widget.ConnectionId
        };
        //console.log(widgetSettingParam);
        widget.hub.invoke('RemoveWidget', widgetSettingParam).then((isWidgetConnected: any) => {
          if (isWidgetConnected) {
          }
        });

        let oldwidgettime = widget.widgetcreationtime;
        let currentDateTime = moment().toDate().getTime();
        widget.widgetcreationtime = currentDateTime;

        let userPref: UserPreference = this._commonService.getUserPreference();

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = "WAVESINQUEUE";
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;
        widgetData.ConnectionId = widget.hub.id;
        widgetData.OldWidgettime = oldwidgettime;

        widget.hub.invoke('GetWidgetData', widgetData)
          .then(data => {
            //console.log('GetWidgetData', data);
          })
          .catch(err => {
            console.log('Error GetWidgetData', err);
          })
      })
      .catch(err => {
        console.log('Error while establishing connection', err);
      });
  }

  remove(widget: any) {
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.hub.start()
      .then(() => {
        let oldwidgettime = widget.widgetcreationtime;
        let widgetSettingParam = {
          WidgetType: "WAVESINQUEUE",
          WidgetId: widget.widgetId,
          CreatedTime: oldwidgettime,
          ConnectionId: widget.ConnectionId
        };
        let currentDateTime = moment().toDate().getTime();
        widget.widgetcreationtime = currentDateTime;

        widget.hub.invoke('RemoveWidget', widgetSettingParam).then((isWidgetConnected: any) => {
          if (isWidgetConnected) {

          }
          console.log('deleteWidget WAVESINQUEUE RemoveWidget');
        });
      })
      .catch(err => {
        console.log('Error while establishing connection', err);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/widgets/wavesinqueue.service.ts